var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('el-button',{staticClass:"export-lecto-btn",attrs:{"type":"primary","size":"medium"},on:{"click":_vm.exportModule}},[_vm._v("导入当前模型")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }